"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseValidation = exports.RequestValidation = exports.Issue = exports.History = exports.SyncRoHistory = exports.HydroTapBridgeHistory = exports.BlackboxHistory = exports.Pelican2History = exports.GbfcHistory = exports.Key = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Telemetry.Schema';
/*
 * `controllers/v2/fleet/telemetry.js` (protocol v1)
 *
 * Request and response are discriminated by `model`: the telemetry keys a
 * caller may ask for, and the items returned, are those of that model's
 * `Telemetry` struct.
 */
const Class = Device.Class;
/** Every telemetry key of every model. A request must only use keys of its `model`. */
exports.Key = effect_1.Schema.Union(effect_1.Schema.keyof(Class.Gbfc.Telemetry), effect_1.Schema.keyof(Class.Pelican2.Telemetry), effect_1.Schema.keyof(Class.Blackbox.Telemetry), effect_1.Schema.keyof(Class.HydroTapBridge.Telemetry), effect_1.Schema.keyof(Class.SyncRo.Telemetry)).annotations({
    identifier: `${exports.NAMESPACE}.Key`,
    title: 'Telemetry key',
});
const LastUpdate = effect_1.Schema.Struct({
    lastUpdate: effect_1.Schema.propertySignature(effect_1.Schema.Number).annotations({ description: 'Sample time, Unix ms' }),
});
const history = (code, telemetry) => effect_1.Schema.Struct({
    model: effect_1.Schema.Literal(code),
    // `partialWith(exact)`: a missing key is omitted, never serialised as `undefined`.
    items: effect_1.Schema.Array(telemetry.pipe(effect_1.Schema.partialWith({ exact: true }), effect_1.Schema.extend(LastUpdate))),
});
exports.GbfcHistory = history(Class.Gbfc.Gbfc.code, Class.Gbfc.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.GbfcHistory`,
});
exports.Pelican2History = history(Class.Pelican2.Pelican2.code, Class.Pelican2.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.Pelican2History`,
});
exports.BlackboxHistory = history(Class.Blackbox.Blackbox.code, Class.Blackbox.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.BlackboxHistory`,
});
exports.HydroTapBridgeHistory = history(Class.HydroTapBridge.HydroTapBridge.code, Class.HydroTapBridge.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.HydroTapBridgeHistory`,
});
exports.SyncRoHistory = history(Class.SyncRo.SyncRo.code, Class.SyncRo.Telemetry).annotations({
    identifier: `${exports.NAMESPACE}.SyncRoHistory`,
});
/** `TelemetryHistoryResponse` */
exports.History = effect_1.Schema.Union(exports.GbfcHistory, exports.Pelican2History, exports.BlackboxHistory, exports.HydroTapBridgeHistory, exports.SyncRoHistory).annotations({
    identifier: `${exports.NAMESPACE}.History`,
    title: 'TelemetryHistoryResponse',
    description: 'Telemetry samples of the device in the range. Each item carries the requested keys that were present in the sample plus `lastUpdate`.',
});
/** `effect/ParseResult` `ArrayFormatter` issue, as the controller returns it. */
exports.Issue = effect_1.Schema.Struct({
    _tag: effect_1.Schema.String,
    path: effect_1.Schema.Array(effect_1.Schema.PropertyKey),
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.Issue`,
    description: 'One schema decoding issue',
});
const invalidRequest = (name, status, description) => effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('INVALID_REQUEST'),
        inputValidation: effect_1.Schema.Array(exports.Issue),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.${name}`,
    title: 'Invalid Request',
    description,
    [platform_1.HttpApiSchema.AnnotationStatus]: status,
});
/** 400: the query does not decode (unknown key for the model, bad range, ...). */
exports.RequestValidation = invalidRequest('RequestValidation', 400, 'The query parameters do not match the request schema of `model`, or `dateRangeStart` is not before `dateRangeEnd`');
/** 422: the stored samples do not decode as the model telemetry. */
exports.ResponseValidation = invalidRequest('ResponseValidation', 422, 'The stored telemetry could not be decoded as the `model` telemetry');
//# sourceMappingURL=schema.js.map